import React from 'react';

interface SectionHeaderProps {
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  return (
    <div className="mb-6 w-full flex items-center gap-2">
      {/* SectionHeading */}
      <h3
        className="text-2xl font-bold whitespace-nowrap"
        style={{
          fontFamily: 'Noto Sans JP',
          color: '#0D357F',
        }}
      >
        {title}
      </h3>

      {/* HorizontalDivider */}
      <div
        className="flex-1 h-px"
        style={{
          background: '#0D357F4D',
        }}
      />
    </div>
  );
};

export default SectionHeader;
